<template>
  <b-container class="rounded contents p-4">
    <section class="p-4" v-if="plan">
      <h3 class="myplan-form-header mb-0">Plan Details</h3>
      <p>Manage or modify your RUSH plan</p>
      <div
        :class="[
          'rounded trial-ticker mb-4 py-3 px-4 align-items-center justify-content-between',
          {
            'd-none': plan.billing_recurrence !== 'trial',
            'd-flex': plan.billing_recurrence === 'trial',
          },
        ]"
      >
        <p class="mb-0">
          Your account is in trial mode. Subscribe to RUSH plan monthly or
          select a one-year for savings of up to 25%.
        </p>
        <b-button variant="primary" class="border-0 px-3">Choose Plan</b-button>
      </div>
      <div class="rounded shadow bg-white mb-4">
        <div class="p-4">
          <h3 class="box-title">Your Plan</h3>
          <b-container>
            <b-row class="plan-main-details">
              <b-col md="2" class="d-flex flex-column justify-content-center">
                <div class="plan-img-container" v-if="plan.plan_name !== 'Professional Plan'">
                  <img
                    :src="plan.plan_logo"
                    :alt="plan.plan_name"
                    class="img-fluid"
                  />
                </div>
                <div class="plan-img-container-default" v-else>
                  <img
                    src="@/assets/images/plan-default-img-03.svg"
                    alt="Professional Plan"
                    class="default-plan"
                  />
                </div>
              </b-col>
              <b-col md="3" class="d-flex flex-column justify-content-center">
                <div class="h5 font-weight-bold mb-0">{{ plan.plan_name }}</div>
                <div
                  class="font-weight-bold"
                  v-if="isIncludedInBillingRecurrences"
                >
                  &#8369;{{
                    currencyFormatter(
                      plan.plan_price *
                        billingRecurrences[plan.billing_recurrence].multiplier
                    )
                  }}/{{ billingRecurrences[plan.billing_recurrence].label }}
                </div>
              </b-col>
              <b-col
                md="3"
                class="
                  d-flex
                  flex-column
                  justify-content-center
                  align-items-center
                  border-left
                "
              >
                <div class="text-left">
                  <div>Billing Type</div>
                  <div
                    class="text-capitalize h5 font-weight-bold"
                    v-if="plan.billing_recurrence !== '-' || plan.plan_name == 'Professional Plan'"
                  >
                    {{ plan.billing_recurrence }}
                  </div>
                  <div class="text-capitalize h5 font-weight-bold" v-else>
                    FREE
                  </div>
                </div>
              </b-col>
              <b-col
                md="3"
                class="
                  d-flex
                  flex-column
                  justify-content-center
                  align-items-center
                  border-left
                "
              >
                <div class="text-left">
                  <div>Plan Status</div>
                  <div class="plan-status my-1" :class="plan.contract_status">
                    {{ isActivePlan ? "Activated" : plan.contract_status }}
                  </div>
                  <small
                    class="text-muted"
                    v-if="$moment(plan.subscription_start_date).isValid()"
                  >
                    Activated since
                    {{
                      $moment(plan.subscription_start_date).format("MM/DD/YYYY")
                    }}
                  </small>
                </div>
              </b-col>
            </b-row>
          </b-container>

          <div class="plan-action-buttons mt-4">
            <b-button
              variant="primary"
              class="px-3 text-white font-weight-normal mr-4"
              v-if="is_show_upgrade"
              @click="handlePlanUpgrade('monthly')"
            >
              <img src="@/assets/images/upgrade-plan-icon.svg" alt="Upgrade" />
              Upgrade Plan
            </b-button>
            <b-button variant="ghost" class="shadow-none" @click="$root.$emit('bv::show::modal', 'myplan-cancel-subscription')" v-if="isCancelSubscriptionVisible">Cancel Subscription</b-button>
            <router-link
              tag="b"
              to="details/manage-subscription"
              class="btn btn-outline px-0 shadow-none"
              >Manage Subscription</router-link
            >
          </div>
        </div>
        <hr class="m-0" />
        <div class="p-4">
          <p class="text-base text-muted mb-1">Next Billing Date</p>
          <p v-if="plan.billing_recurrence !== 'trial'" class="text-base">
            {{
              plan.billing_recurrence == "-"
                ? "Not Applicable"
                : "on " + transformDate(plan.next_billing_date)
            }}
          </p>
          <p v-else class="text-base">Your trial has 14 days remaining</p>
        </div>
        <hr class="m-0" />
        <div
          class="
            p-4
            d-flex
            flex-column flex-md-row
            align-items-start align-items-md-center
            justify-content-between
          "
        >
          <h3 class="text-main font-weight-bold text-base mb-0">
            Running Total
          </h3>
          <div>
            <h3 class="box-title text-right">
              &#8369;{{ currencyFormatter(plan.charges_total_amount) }}
            </h3>
            <div
              id="cost-breakdown"
              v-b-modal.cost-breakdown-modal
              v-if="plan.billing_recurrence != '-'"
            >
              See cost breakdown
            </div>
          </div>
        </div>
      </div>
      <div class="payment-methods rounded shadow bg-white mb-4 p-4">
        <h3 class="box-title mb-4">Payment Method</h3>
        <div
          class="d-flex w-100 justify-content-between mb-4"
          v-if="plan.payment_methods.length > 0"
        >
          <div class="payment-method-list w-100">
            <div
              :class="[
                'item d-flex align-items-center border rounded p-3',
                {
                  'mb-3': index < plan.payment_methods.length - 1,
                },
              ]"
              v-for="(item, index) in plan.payment_methods"
              :key="`payment-item-${index}`"
            >
              <div class="rounded border py-2 px-3 mr-2">
                <img
                  v-if="item.card_brand === 'VISA'"
                  :src="require('@/assets/images/visa.png')"
                  class="card-brand img-fluid"
                  alt="item.card_brand"
                />
                <img
                  v-else-if="item.card_brand === 'MASTERCARD'"
                  :src="require('@/assets/images/mastercard.png')"
                  class="card-brand img-fluid"
                  alt="item.card_brand"
                />
                <img
                  v-else-if="item.card_brand === 'JCB'"
                  :src="require('@/assets/images/jcb.png')"
                  class="card-brand img-fluid"
                  alt="item.card_brand"
                />
              </div>
              <div class="card-display py-2 px-3 mr-2">
                <span v-html="digitPlaceholder" class="mr-2"></span>
                <span v-html="digitPlaceholder" class="mr-2"></span>
                <span v-html="digitPlaceholder" class="mr-2"></span>
                {{ item.card_last_four_digit }}
              </div>
              <div class="card-order flex-grow-1">
                <b-button variant="primary-card" v-if="item.is_primary"
                  >Primary</b-button
                >
                <b-button variant="secondary-card" v-if="!item.is_primary"
                  >Secondary</b-button
                >
              </div>
              <b-button
                variant="ghost"
                class="btn-make-primary"
                v-if="!item.is_primary"
                @click="makeAsPrimary(item)"
                :disabled="loading"
              >
                Make Primary
              </b-button>
              <b-button
                variant="ghost"
                class="btn-remove-credit-card"
                @click="showConfirmRemoveCard(item)"
                v-if="plan.payment_methods.length > 1"
                :disabled="loading"
              >
                Remove
              </b-button>
            </div>
          </div>
        </div>
        <p class="text-muted mb-4" v-else>No payment method added</p>
        <template
          v-if="
            plan.payment_methods.length > 1 || (plan.billing_recurrence === '-' && plan.plan_name !== 'Professional Plan')
          "
        >
          <b-button variant="outline" class="px-4" disabled
            >Add payment method</b-button
          >
        </template>
        <template v-else>
          <router-link
            tag="b"
            to="add-credit-card"
            class="btn btn-outline px-4 shadow-none"
            >Add payment method</router-link
          >
        </template>
      </div>
    </section>
    <CancelSubscriptionModal
      @subscriptionCancelled="handleCancelledSubcription"
    />
    <cost-breakdown-modal />
    <ConfirmRemoveCardModal
      @deleteCard="deleteCard"
      @resetDeleteCardInfo="deleteCardInfo = null"
    />
  </b-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import CancelSubscriptionModal from "@/components/my-plan/CancelSubscriptionModal";
import ConfirmRemoveCardModal from "@/components/my-plan/ConfirmRemoveCardModal";
import CostBreakdownModal from "@/components/my-plan/CostBreakdownModal";
import _ from "lodash";

const currencyFormatter = value => {
    return Number(parseFloat(value).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2
    });
};

export default {
    name: "MyPlanDetails",
    components: {
        CancelSubscriptionModal,
        CostBreakdownModal,
        ConfirmRemoveCardModal
    },
    data() {
        return {
            currencyFormatter: currencyFormatter,
            is_show_upgrade: false,
            deleteCardInfo: null,
            billingRecurrences: {
                monthly: {
                    multiplier: 1,
                    label: "month"
                },
                quarterly: {
                    multiplier: 3,
                    label: "quarter"
                },
                "bi-annual": {
                    multiplier: 6,
                    label: "6 months"
                },
                yearly: {
                    multiplier: 12,
                    label: "year"
                }
            },
            isCancelSubscriptionVisible: false
        };
    },
    computed: {
        ...mapGetters({
            loading: "myPlan/loading",
            errors: "myPlan/errors",
            plan: "myPlan/plan",
            user: "auth/user"
        }),
        ...mapState("accountProfile", ["detail"]),
        ...mapGetters("accountProfile", ["planDetails"]),
        digitPlaceholder() {
            return "&#8226; &#8226; &#8226; &#8226;";
        },
        isActivePlan() {
            return this.plan && this.plan.contract_status
                ? ["new", "live"].includes(this.plan.contract_status)
                : false;
        },
        isIncludedInBillingRecurrences() {
            return Object.keys(this.billingRecurrences).includes(
                this.plan.billing_recurrence
            );
        }
    },
    created() {
        this.getPlanDetails();
    },
    methods: {
        ...mapActions({
            getPlanDetails: "myPlan/getPlanDetails",
            cancelSubscription: "myPlan/cancelSubscription",
            removePaymentMethod: "myPlan/removePaymentMethod",
            makePrimaryPaymentMethod: "myPlan/makePrimaryPaymentMethod"
        }),
        transformDate(date) {
            return this.$moment(date).format("MMMM DD, YYYY");
        },
        choosePlan(type) {
            this.plan.billing_recurrence = type;
        },
        handlePlanUpgrade(type) {
            this.choosePlan(type);
            this.is_show_upgrade = false;
        },
        async handleCancelledSubcription(reason) {
            const payload = {
                merchant_uuid: this.user.merchant_uuid,
                plan_uuid: this.plan.plan_uuid,
                reason_for_cancellation: reason
            };
            await this.cancelSubscription(payload);
            if (!this.errors || Object.keys(this.errors).length === 0) {
                this.$nextTick(() => {
                    this.$root.$emit(
                        "bv::hide::modal",
                        "myplan-cancel-subscription"
                    );
                    this.$root.$emit("subscriptionCancelled");
                });
            }
        },
        async makeAsPrimary(item) {
            const payload = {
                token_uuid: item.uuid
            };
            await this.makePrimaryPaymentMethod(payload);
            if (_.isEmpty(this.errors)) this.getPlanDetails();
        },
        showConfirmRemoveCard(item) {
            this.deleteCardInfo = item;
            this.$root.$emit("bv::show::modal", "confirm-remove-card");
        },
        async deleteCard() {
            const payload = {
                uuid: this.deleteCardInfo.uuid
            };
            await this.removePaymentMethod(payload);
            if (_.isEmpty(this.errors)) this.getPlanDetails();
        },
        callCardBrandImage(brand) {},
    }
};
</script>

<style lang="scss" scoped>
.plan-main-details {
    background: #fcfcfc;
    border: 1px solid #eaeaeb;
    border-radius: 8px;
    padding: 20px;
    margin-top: 15px;
}
.plan-img-container {
    width: 110px;
    height: 59px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1.15789px solid #e9ebed;
    border-radius: 8px;
    padding: 19px 10px;
    background: #ffffff;
}
.plan-img-container-default {
    width: 110px;
    height: 59px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1.15789px solid #e9ebed;
    border-radius: 8px;   
    background: #E9EBED;
}

.default-plan {
  width: 30%;
  height: auto;
}
.plan-details {
    .price {
        font-size: 15px;
        font-family: MainFontRegular, sans-serif;
    }
}
.plan-type {
    & > * {
        font-size: 14px;
        font-family: MainFontRegular, sans-serif;
    }
    .plan-type-value {
        background-color: #68737d;
        border-radius: 34px !important;
    }
}
.trial-ticker {
    background-color: #2f3941;
    color: white;
    p {
        max-width: 450px;
        width: 100%;
    }
    .btn.btn-primary {
        border-radius: 31px;
        background-color: #ff5c00;
    }
}
h4 {
    font-size: 14px;
    font-weight: normal;
    font-family: MainFontBold, sans-serif;
}
.plan-action-buttons .btn {
    font-size: 16px;
    font-weight: normal;
    font-family: MainFontBold, sans-serif;
    border-radius: 74px !important;
    color: #68737d;
    &.btn-ghost {
        color: #68737d;
    }
}
.payment-methods {
    .btn {
        &.btn-outline {
            border-radius: 74px;
            border: solid 1.5px #000;
            font-size: 16px;
            font-weight: normal;
            font-family: MainFontBold, sans-serif;
        }
        &.btn-ghost {
            color: #5182ff;
            font-size: 14px;
            font-family: MainFontRegular, sans-serif;
        }
    }
    .item {
        & > div > span {
            letter-spacing: -2px;
        }
        .primary-payment {
            font-size: 14px;
            font-family: MainFontRegular, sans-serif;
            color: #5182ff;
            border: 1px solid #5182ff !important;
            background-color: rgba(81, 130, 255, 0.05);
        }
        .btn.btn-primary-card {
            background-color: #5182ff !important;
            text-transform: uppercase;
            color: #fff;
            font-family: MainFontRegular, sans-serif;
            pointer-events: none;
        }
        .btn.btn-secondary-card {
            background-color: #68737d !important;
            text-transform: uppercase;
            color: #fff;
            font-family: MainFontRegular, sans-serif;
            pointer-events: none;
        }
        .btn.btn-remove-credit-card {
            color: #68737d !important;
        }
        .card-brand {
            width: 35px;
        }
    }
}
.text-base {
    font-size: 16px;
}
#cost-breakdown {
    color: #5182ff;
    font-size: 14px;
    cursor: pointer;
}
.plan-status {
    background: #6c757d;
    border-radius: 34px;
    width: 100px;
    height: 25px;
    padding: 0 13px;
    color: #ffffff;
    text-align: center;
    text-transform: capitalize;
    &.active {
        background: #3bb56c;
    }
    &.new,
    &.live {
        background: #3bb56c;
        color: #ffffff;
    }
    &.suspended {
        background: #ffc7ac;
        color: #b0633e;
    }
    &.terminated {
        background: #ffdde1;
        color: #d62a3d;
    }
}
</style>
